import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot } from '@angular/router';

import { toCommand } from './to-command';

/**
 * A handler that causes a redirect to the specified route.
 *
 * @param urlOrCommands
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const redirectTo = (urlOrCommands: string | any[]) => {
    return (route: ActivatedRouteSnapshot) =>
        createUrlTreeFromSnapshot(route, toCommand(urlOrCommands));
};
